import Tone from 'tone';
import {lstorage} from 'utils/lstorage.js';
import { setAudioInputSource } from "actions/index.js";

class AudioInputManager {

    constructor(store) {
        this.store = store;
        this.input = undefined;
        if (Tone.Master.context.isOffline) {
            return;
        }
        this.setupRecording();
        this.splitter = undefined;

        this.init();
        this.deviceId = undefined;
    }

    async init() {
        if (window.explore || window.isNFT) {
            return;
        }
        let deviceId = !window.isNFT && lstorage.getItem('deviceId');
        if (deviceId !== undefined) {
            // see if it exists here...
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                return;
            }
            let devices = await navigator.mediaDevices.enumerateDevices();
            if (devices.some(d => d.deviceId === deviceId)) {
                // then we have it
                let stream = await navigator.mediaDevices.getUserMedia({
                    audio: {deviceId: deviceId, echoCancellation : false}
                });

                console.log('setting to input = ' + deviceId);
                this.newInputSource(stream, deviceId);
            }
        }
    }

    getInputChannels() {
        return this.input === undefined ? [] : [1, 2];
    }

    connect(output, channelNumber) {
        if (channelNumber == 1) {
            this.splitter.left.connect(output);
        } else {
            this.splitter.right.connect(output);
        }
    }

    disconnect(output, channelNumber) {
        if (channelNumber == 1) {
            this.splitter.left.disconnect();
        } else {
            this.splitter.right.disconnect();
        }
    }

    getRecorder() {
        return new window.Recorder(this.input, {numChannels: 1, bufferLen: 1024});
    }

    newInputSource(stream, deviceId) {
        if (this.input && this.splitter) {
            /*
            this.input.disconnect();
            this.splitter.disconnect();
            */
        }

        this.startUserMedia(stream);
        if (deviceId) {
            this.deviceId = deviceId;
        }

        this.store.dispatch(setAudioInputSource(deviceId));
    }

    startUserMedia(stream) {
        if (Tone.Master.context.isOffline) {
            return;
        }
        this.input = this.audioContext.createMediaStreamSource(stream);
        this.splitter = new Tone.Split();
        this.input.connect(this.splitter);
    }

    dispose() {
        if (this.splitter) {
            this.splitter.dispose();
        }
        if (this.input) {
            this.input.disconnect();
        }
        this.input = undefined;
        this.splitter = undefined;
    }

    setupRecording() {
        if (Tone.Master.context.isOffline || window.explore) {
            return;
        }
        try {
            // webkit shim
            window.AudioContext = Tone.Master.context;//window.AudioContext || window.webkitAudioContext;
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
            window.URL = window.URL || window.webkitURL;
            
            this.audioContext = Tone.Master.context;
        } catch (e) {
            console.log('No web audio support in this browser!');
        }

        if (navigator.mediaDevices === undefined ||
            !navigator.mediaDevices.getUserMedia) {
            return;
        }

        navigator.mediaDevices.getUserMedia(
            {
                audio: {
                    mandatory: { echoCancellation : false}
                }
            })
            .then(
                (stream) => this.startUserMedia(stream))
            .catch(function(e) {
                console.log('No live audio input: ' + e);
            });
    }
}

export default AudioInputManager;
